import { render } from "./wrench.svg?vue&type=template&id=6d7504ed?inline"
const script = {}
script.render = render

export default script